import { ChallengeArtifactsSection } from '@/components/artifacts';
import { ChallengeCollectiblesSection } from '@/components/collectibles';
import { useCallback } from 'react';
import { sectionAnchorId } from '../sectionRegistry';
import type { ChallengeEditorSectionHandle, RegisterSectionHandle } from '../types';

interface RewardsSectionProps {
  eventId: string;
  challengeId: string;
  registerSectionHandle: RegisterSectionHandle;
}

/**
 * Event-edit rewards: collectible awards/requirements + artifact rewards.
 * Both inner sections run in `controlled` mode — their internal Save buttons
 * are hidden and their `{ isDirty, save }` handles ride the editor's single
 * Save via the section-handle registry.
 */
export function RewardsSection({
  eventId,
  challengeId,
  registerSectionHandle,
}: RewardsSectionProps) {
  const registerCollectibles = useCallback(
    (handle: ChallengeEditorSectionHandle | null) =>
      registerSectionHandle('rewards-collectibles', handle),
    [registerSectionHandle],
  );
  const registerArtifacts = useCallback(
    (handle: ChallengeEditorSectionHandle | null) =>
      registerSectionHandle('rewards-artifacts', handle),
    [registerSectionHandle],
  );

  return (
    <div id={sectionAnchorId('rewards')} className="scroll-mt-6 space-y-6">
      <ChallengeCollectiblesSection
        ownerId={eventId}
        apiBase={`/events/${eventId}`}
        keyPrefix="Event"
        challengeId={challengeId}
        mode="controlled"
        onRegisterHandle={registerCollectibles}
      />
      <ChallengeArtifactsSection
        ownerId={eventId}
        apiBase={`/events/${eventId}`}
        keyPrefix="Event"
        challengeId={challengeId}
        mode="controlled"
        onRegisterHandle={registerArtifacts}
      />
    </div>
  );
}
